import React from "react";
import DirectContact from "./components/DirectContact";
import ConsultationForm from "./components/ConsultationForm";

export default function Contact() {
  return (
    <>
      <DirectContact />
      <ConsultationForm />
    </>
  );
}
